import { render, staticRenderFns } from "./AuthBrandHeader.vue?vue&type=template&id=504a4062&scoped=true&"
import script from "./AuthBrandHeader.vue?vue&type=script&lang=js&"
export * from "./AuthBrandHeader.vue?vue&type=script&lang=js&"
import style0 from "./AuthBrandHeader.vue?vue&type=style&index=0&id=504a4062&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504a4062",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
